import { ExpertAnketaTableOfContents } from './ExpertAnketaTableOfContents';

export default ExpertAnketaTableOfContents;